// IMPORT:
var prefabs;
var THREE;
var sid = 0;

// GAME OBJECT:
function GameObject(data) {
  this.sid = sid++;
  this.uid = data.uid;
  this.width = data.w;
  this.length = data.l;
  this.height = data.h;
  this.active = true;
  this.x = data.x;
  this.orgX = this.x;
  this.y = data.y;
  this.orgY = this.y;
  this.z = data.z;
  this.orgZ = this.z;
  this.dir = data.d;
  this.src = data.src;
  this.ramp = data.ramp;
  this.ladder = data.ladder;
  this.jumpPad = data.jumpPad;
  this.noShoot = data.noShoot;
  this.stepSrc = data.s;
  this.score = data.score;
  this.scoreP = data.scoreP;
  this.kill = data.kill;
  this.dummy = data.dummy;
  this.noVis = data.noVis;
  this.complexMesh = data.complexMesh;
  this.penetrable = data.penetrable;
  this.health = data.health;
  this.startHealth = data.health;
  this.transparent = data.transparent;
  this.boost = data.boost;
  this.boostDr = data.boostDr;
  this.aoMlt = data.aoM;
  this.team = data.team;
  this.flag = data.flag;
  this.trigger = data.trigger;
  this.pickup = data.pickup;
  this.orgPickup = data.orgPickup;
  this.pickupRep = data.pickupRep;
  this.meshRef = data.meshRef;
  this.checkpoint = data.checkpoint;
  this.singleUse = data.singleUse;
  this.isBorder = data.isBorder;
  this.node = data.node;
  this.channel = data.channel;
  this.teleporter = data.teleporter;
  this.telCooldown = 0;
  this.telStopMo = data.momentum;
} // OBJECT MANAGER:
module.exports.manager = function (RENDER, UTILS, config) {
  // INIT:
  if (RENDER) {
    prefabs = require(/*! ../data/prefabs.js */"./prefabs.js").prefabs;
    THREE = require("three");
  }
  this.aoOpac = 0;
  this.objects = [];
  this.objectives = [];
  this.flags = [];
  this.pickups = [];
  this.teleporters = [];
  var tmpObj;
  var tmpObj2; // COLLISION:
  this.collision = function (obj, other, pad) {
    return obj.x - obj.width - pad <= other.x + other.width && obj.x + obj.width + pad >= other.x - other.width && obj.z - obj.length - pad <= other.z + other.length && obj.z + obj.length + pad >= other.z - other.length && obj.y - obj.height - pad <= other.y + other.height && obj.y + obj.height + pad >= other.y - other.height;
  };

  // CHECK POS:
  this.checkPos = function (x, y, z, obj1, obj2) {
    for (var i = 0; i < this.objects.length; ++i) {
      if (this.objects[i] != obj1 && this.objects[i] != obj2 && !this.objects[i].ramp && UTILS.pointInBox3D(x, y, z, this.objects[i])) {
        return false;
      }
    }
    return true;
  };

  // ADD CYLINDER:
  this.addCylinder = function (x, y, z, s, h, data) {
    if (RENDER) {
      data.shadows = true;
      RENDER.addCylinder(x, y, z, s, h, data);
    }
  };

  // ADD FLAG:
  this.getZoneDat = function (team, player) {
    return {
      src: "zone_r",
      texSrc: "zone_" + (player ? team == player.team ? "b" : "r" : "r"),
      noGroup: true,
      mat: THREE.MeshBasicMaterial,
      transparent: true,
      depthWrite: false,
      side: 2
    };
  };
  this.getFlagDat = function (team, player) {
    var cInd = player ? team == player.team ? "1" : "0" : "0";
    return {
      src: "crystal_0",
      texSrc: "crystal_" + cInd,
      noGroup: true,
      noShadow: true,
      noFog: true,
      emissive: cInd == "0" ? 0x853434 : 0x428a9d
    };
  };
  this.addFlag = function (x, y, z, team) {
    var flagMesh = null;
    if (RENDER) {
      flagMesh = RENDER.loadMesh(this.getFlagDat(team), x, y + config.flagOff, z, 0, config.flagScale, RENDER.scene);
      flagMesh.layers.set(2);
      flagMesh.zoneMesh = RENDER.addCube(x, y, z, config.flagZoneS, config.flagZoneH, config.flagZoneS, [1, 1, 0, 0, 1, 1], this.getZoneDat(team));
    }
    var tmpFlg = new GameObject({
      uid: this.objects.length,
      meshRef: flagMesh,
      x: x,
      z: z,
      y: y + config.flagScale / 2 + config.flagOff,
      w: config.flagScale,
      l: config.flagScale,
      h: config.flagScale / 2,
      team: team,
      flag: true,
      noShoot: true,
      complexMesh: true
    });
    this.flags.push(tmpFlg);
    this.objects.push(tmpFlg);
    var tmpZon = new GameObject({
      x: x,
      z: z,
      y: y + config.flagZoneH / 2,
      w: config.flagZoneS / 2,
      l: config.flagZoneS / 2,
      h: config.flagZoneH / 2,
      team: team,
      trigger: true,
      noShoot: true,
      complexMesh: true
    });
    tmpZon.flagObj = tmpFlg;
    this.objects.push(tmpZon);
  };

  // ADD WEAPON PICKUP:
  this.addWeapon = function (x, y, z, xR, yR, zR, id, wep, norep) {
    var wepMesh = null;
    if (RENDER) {
      wepMesh = RENDER.loadMesh({
        src: "weapons/" + wep.src,
        texSrc: "weapons/" + wep.src,
        noGroup: true,
        noShadow: true,
        transparent: true,
        noFog: true
      }, x, y + config.pickupOff, z, 0, wep.scale, RENDER.scene);
      wepMesh.rotateY(xR || 0);
      wepMesh.rotateX((yR || 0) - Math.PI / 2);
      wepMesh.rotateZ(zR || 0);
    }
    var tmpWep = new GameObject({
      uid: this.objects.length,
      meshRef: wepMesh,
      x: x,
      z: z,
      y: y + config.pickupZoneH / 2,
      w: config.pickupZoneX,
      l: config.pickupZoneZ,
      h: config.pickupZoneH * 2,
      pickup: id,
      pickupRep: !norep,
      orgPickup: id,
      trigger: true,
      noShoot: true,
      complexMesh: true
    });
    this.pickups.push(tmpWep);
    this.objects.push(tmpWep);
  };

  // ADD OBJECTIVE:
  this.addObjective = function (x, y, z, w, l, h) {
    var tmpMesh;
    if (RENDER) {
      tmpMesh = RENDER.addCube(x, y, z, w, h, l, [1, 1, 0, 0, 1, 1], {
        src: "objective_0",
        noGroup: true,
        mat: THREE.MeshBasicMaterial,
        transparent: true,
        depthWrite: false,
        side: 2
      });
      tmpMesh.visible = false;
    }
    this.objectives.push({
      x: x,
      z: z,
      y: y + h / 2,
      mesh: tmpMesh,
      width: w / 2,
      length: l / 2,
      height: h / 2
    });
  };

  // ADD DEATH ZONE:
  this.addDeathZone = function (x, y, z, w, l, h) {
    this.objects.push(new GameObject({
      x: x,
      z: z,
      y: y + h / 2,
      w: w / 2,
      l: l / 2,
      h: h / 2,
      kill: true,
      noShoot: true,
      complexMesh: true
    }));
  };

  // ADD SCORE ZONE:
  this.addScoreZone = function (x, y, z, w, l, h, sp) {
    this.objects.push(new GameObject({
      x: x,
      z: z,
      y: y + h / 2,
      w: w / 2,
      l: l / 2,
      h: h / 2,
      score: true,
      scoreP: sp,
      noShoot: true,
      complexMesh: true
    }));
  };

  // ADD CHECK POINT:
  this.addCheckPoint = function (x, y, z, w, l, h, su, dir) {
    this.objects.push(new GameObject({
      x: x,
      z: z,
      y: y + h / 2,
      w: w / 2,
      l: l / 2,
      h: h / 2,
      d: parseInt(dir) || 0,
      checkpoint: true,
      singleUse: su,
      noShoot: true,
      complexMesh: true
    }));
  };

  // ADD TELEPORTER:
  this.addTeleporter = function (x, y, z, w, l, h, ch, n, m) {
    var tmp = new GameObject({
      uid: this.objects.length,
      x: x,
      z: z,
      y: y + h / 2,
      w: w / 2,
      l: l / 2,
      h: h / 2,
      teleporter: true,
      channel: ch || 0,
      node: n || 0,
      momentum: m,
      noShoot: true,
      complexMesh: true
    });
    this.objects.push(tmp);
    this.teleporters.push(tmp);
  };

  // ADD GRASS:
  this.addGrass = function (x, y, z, w, h, l, data) {
    data = data || {};
    if (RENDER && !data.noVis) {
      data.side = THREE.DoubleSide;
      data.transparent = true;
      data.alphaTest = 0.2;
      data.vertexColors = THREE.VertexColors;
      data.shadowsR = true;
      data.noGroup = !!data.health;
      RENDER.addGrass(x, y, z, w, h, l, data);
    }
  };

  // ADD LADDER:
  this.addLadder = function (x, y, z, h, d, vis, tex, colr) {
    var tW = config.ladderScale;
    var tL = config.ladderScale;
    if (d == 0 || d == Math.PI) {
      tL = config.ladderWidth;
    } else {
      tW = config.ladderWidth;
    }
    tmpObj = new GameObject({
      ladder: true,
      complexMesh: true,
      noShoot: true,
      d: d,
      x: x + config.ladderScale * Math.cos(d),
      z: z + config.ladderScale * Math.sin(d),
      y: y,
      w: tW,
      l: tL,
      h: h
    });
    this.objects.push(tmpObj);
    if (RENDER && !vis) {
      var tmpDat = {
        src: tex || "floor_0",
        vertexColors: THREE.VertexColors,
        colr: colr,
        scale: 0.02,
        amb: config.ambientVal,
        shadows: true
      };
      RENDER.addCube(tmpObj.x + config.ladderWidth * Math.sin(d), tmpObj.y, tmpObj.z + config.ladderWidth * Math.cos(d), config.ladderScale * 2, h + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], tmpDat);
      RENDER.addCube(tmpObj.x - config.ladderWidth * Math.sin(d), tmpObj.y, tmpObj.z - config.ladderWidth * Math.cos(d), config.ladderScale * 2, h + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], tmpDat);
      var stepH = 6;
      var max = Math.floor(h / stepH);
      for (var i = 0; i < max; ++i) {
        tmpDat.dark = 0.6 + (1 - 0.6) * (i / max);
        RENDER.addPlane(tmpObj.x, y + stepH * (i + 1) + UTILS.randFloat(-1, 1), tmpObj.z, config.ladderWidth, config.ladderScale, tmpDat, -d + Math.PI / 2, Math.PI / 2, UTILS.randFloat(-0.1, 0.1));
      }
    }
  };

  // ADD RAMP:
  this.addRamp = function (x, y, z, w, h, l, dir, boost, tex, vis, colr, ambS, movT, movD) {
    var rot = dir != 0 && dir != Math.PI;
    var tW = (rot ? l : w) / 2;
    var rl = Math.sqrt(h * h + l * l);
    var xD = Math.asin(h / rl);
    this.objects.push(new GameObject({
      x: x,
      z: z,
      y: y + h / 2,
      w: w / 2,
      l: l / 2,
      h: h / 2,
      d: dir,
      noShoot: true,
      complexMesh: true,
      boostDr: boost ? xD : null,
      boost: boost ? boost : null,
      ramp: {
        sX: x - tW * Math.cos(dir),
        sZ: z - tW * Math.sin(dir),
        eX: x + tW * Math.cos(dir),
        eZ: z + tW * Math.sin(dir)
      }
    }));
    if (RENDER && !vis) {
      var tmpDat = {
        src: tex || "default",
        vertexColors: THREE.VertexColors,
        colr: colr,
        scale: 1,
        shadowsR: true,
        side: THREE.DoubleSide,
        movT: movT,
        movD: movD
      };
      tmpDat.transparent = tmpDat.src == "link_0";
      if (tmpDat.src == "link_0") {
        tmpDat.depthWrite = true;
        tmpDat.alphaTest = tmpDat.transparent ? 0.02 : 0;
      }
      RENDER.addRamp(x, y, z, rot ? w : l, h, (rot ? l : w) / 2, dir, tmpDat);
      y += config.ambOff;
      var tmpV = (rot ? w : l) / 2 - ambS;
      if (rot) {
        w = ambS * 2;
      } else {
        l = ambS * 2;
      }
      for (var i = 0; i < 2; ++i) {
        var tm = i ? 1 : -1;
        RENDER.addRamp(x + tmpV * tm * Math.cos(dir + Math.PI / 2), y, z + tmpV * tm * Math.sin(dir + Math.PI / 2), rot ? w : l, h, (rot ? l : w) / 2, dir, {
          src: "ambient_1",
          euler: "ZYX",
          depthWrite: false,
          transparent: true,
          side: THREE.DoubleSide
        }, i ? 0 : Math.PI);
      }
    }
  };

  // ADD BOX:
  this.addBlock = function (x, y, z, w, l, h, s, data) {
    data = data || {};
    data.src = data.src || "wall_0";
    if (!data.noCol) {
      this.objects.push(new GameObject({
        x: x,
        z: z,
        y: y + h / 2,
        w: w / 2,
        l: l / 2,
        h: h / 2,
        uid: this.objects.length,
        s: data.sound,
        src: data.src,
        noVis: data.noVis,
        health: data.health,
        transparent: data.transparent,
        penetrable: data.penetrable,
        isBorder: data.isBorder,
        complexMesh: data.xR || data.yR || data.zR || data.src == "link_0",
        ter: true,
        trigger: data.trig,
        event: data.ev,
        func: data.func
      }));
    }
    if (RENDER && !data.noVis) {
      data.transparent = data.src == "link_0" || data.opacity != 1;
      if (data.src == "link_0") {
        data.depthWrite = data.opacity == 1;
        data.alphaTest = data.transparent ? 0.02 : 0;
      }
      data.vertexColors = THREE.VertexColors;
      data.scale = data.scale == undefined ? 1 : data.scale;
      data.shadows = !data.shadowsR && data.opacity == 1;
      data.noFog = !!data.emissive;
      data.noGroup = !!data.health;
      var tmpM = RENDER.addCube(x, y, z, w, h, l, s, data);
      if (data.health && !data.noCol) {
        this.objects[this.objects.length - 1].meshRef = tmpM;
      }
    }
  };

  // ADD MESH:
  this.addMesh = function (x, y, z, r, w, h, l, id, noCol, colr) {
    y += h;
    if (!noCol) {
      this.objects.push(new GameObject({
        complexMesh: prefabs ? prefabs[id.toUpperCase()].complex : false,
        aoM: prefabs ? prefabs[id.toUpperCase()].aoMlt || 0 : 0,
        x: x,
        z: z,
        y: y,
        w: w,
        l: l,
        h: h,
        ter: true
      }));
    }
    if (prefabs && prefabs[id.toUpperCase()].transparent) {
      y += UTILS.randFloat(-0.01, 0.01);
    }
    if (RENDER) {
      RENDER.loadMesh({
        src: id + "_0",
        emissive: prefabs[id.toUpperCase()].emiss ? 0xffffff : null,
        side: prefabs[id.toUpperCase()].doubleSide ? THREE.DoubleSide : THREE.FrontSide,
        transparent: prefabs[id.toUpperCase()].transparent,
        shadows: prefabs[id.toUpperCase()].castShadow,
        shadowsR: prefabs[id.toUpperCase()].receiveShadow,
        vertexColors: THREE.VertexColors,
        color: colr || 0xffffff
      }, x, y, z, r, config[id + "Scale"], RENDER.scene, true);
    }
  };

  // ADD NOISE PLANES:
  var noisePlanes = [];
  this.addNoisePlanes = function () {
    for (var i = 0; i < noisePlanes.length; ++i) {
      noisePlanes[i][5].objects = this.objects;
      RENDER.addPlane(...noisePlanes[i]);
    }
    noisePlanes.length = 0;
  };

  // ADD PLANE:
  this.addPlane = function (x, y, z, h, l, data, xR, yR, zR) {
    data = data || {};
    if (data.col) {
      this.objects.push(new GameObject({
        x: x,
        z: z,
        y: y,
        w: l,
        l: h,
        h: 0,
        s: data.sound,
        health: data.health,
        transparent: data.transparent,
        penetrable: data.penetrable,
        noVis: data.noVis
      }));
    }
    if (RENDER && !data.noVis) {
      data.transparent = true;
      data.side = THREE.DoubleSide;
      data.vertexColors = THREE.VertexColors;
      if (data.noise) {
        data.pinEdges = true;
        data.margin = 1;
        data.tilesX = Math.round(l / 5);
        data.tilesZ = Math.round(h / 5);
      }
      var tmpDat = [x, y, z, l, h, data, xR, (yR || 0) + Math.PI / 2, zR];
      if (data.noise) {
        noisePlanes.push(tmpDat);
      } else {
        return RENDER.addPlane(...tmpDat);
      }
    }
  };

  // CHECK IF POINT IS INSIDE ANY OBJECTS:
  this.pointInObjs = function (pnt, parents, marg) {
    for (var i = 0; i < this.objects.length; ++i) {
      tmpObj = this.objects[i];
      if (!tmpObj.noVis && !tmpObj.complexMesh && !tmpObj.health && parents.indexOf(tmpObj.sid) < 0 && UTILS.pointInBox3D(pnt[0], pnt[1], pnt[2], tmpObj, marg || 0)) {
        return true;
      }
    }
    return false;
  };

  // SET MAX AO:
  this.setMaxAO = function (obj1, obj2, ao) {
    obj1.maxAOS = obj1.maxAOS || {};
    obj1.maxAOS[obj2.sid] = Math.max(ao, obj1.maxAOS[obj2.sid] || 0);
    obj2.maxAOS = obj2.maxAOS || {};
    obj2.maxAOS[obj1.sid] = Math.max(ao, obj2.maxAOS[obj1.sid] || 0);
  };

  // ADD AMBIENT:
  this.aosToAdd = {};
  this.addAmbient = function (x, y, z, xD, yD, zD, w, h, i, par, grp, orgn) {
    var doAdd = !par;
    if (par) {
      for (var ind = 0; ind < par.length; ++ind) {
        if (UTILS.pointInBox3D(x, y, z, par[ind], config.ambOff * 2)) {
          doAdd = true;
          break;
        }
      }
    }
    if (doAdd) {
      if (par) {
        var tmpSID = par[0].sid + "-" + par[1].sid;
        if (!this.aosToAdd[tmpSID]) {
          this.aosToAdd[tmpSID] = [];
        }
        this.aosToAdd[tmpSID].push({
          vals: [x, y, z, xD, yD, zD, w + config.ambOff, h + config.ambOff, i],
          group: grp
        });
      } else {
        this.addPlane(x, y, z, w, h, {
          src: "ambient_" + (i || 0),
          euler: "ZYX",
          depthWrite: false
        }, xD, yD, zD);
      }
    }
  };
  var matchedGroups = [["g6-1-2", "g4-1-2"], ["g5-1-2", "g4-0-1"], ["g6-0-1", "g3-1-2"], ["g5-0-1", "g3-0-1"], ["g6-0-3", "g2-0-3"], ["g5-0-3", "g2-1-1"], ["g6-1-1", "g1-0-3"], ["g5-1-1", "g1-1-1"], ["g6-0-2", "g1-1-0"], ["g5-0-2", "g1-0-2"], ["g6-1-0", "g2-1-0"], ["g5-1-0", "g2-0-2"], ["g4-0-2", "g1-0-0"], ["g3-0-2", "g1-1-3"], ["g4-1-0", "g2-0-0"], ["g3-1-0", "g2-1-3"], ["g4-0-3", "g2-1-2"], ["g3-0-3", "g2-0-1"], ["g4-1-1", "g1-1-2"], ["g3-1-1", "g1-0-1"], ["g6-1-3", "g3-0-0"], ["g5-1-3", "g3-1-3"], ["g6-0-0", "g4-0-0"], ["g5-0-0", "g4-1-3"]];
  this.groupsMatch = function (group1, group2) {
    for (var i = 0; i < matchedGroups.length; ++i) {
      if (matchedGroups[i].indexOf(group1) >= 0 && matchedGroups[i].indexOf(group2) >= 0) {
        return true;
      }
    }
    return false;
  };
  this.clearAOGroup = function (group) {
    for (var i = group.length - 1; i >= 0; --i) {
      tmpObj = group[i];
      for (var x = group.length - 1; x >= 0; --x) {
        tmpObj2 = group[x];
        if (!tmpObj.dontAdd && !tmpObj2.dontAdd && tmpObj != tmpObj2 && this.groupsMatch(tmpObj.group, tmpObj2.group)) {
          if (tmpObj.vals[6] + tmpObj.vals[7] >= tmpObj2.vals[6] + tmpObj2.vals[7]) {
            tmpObj2.dontAdd = true;
          } else {
            tmpObj.dontAdd = true;
          }
          break;
        }
      }
    }
  };
  this.addPendingAOs = function () {
    for (var group in this.aosToAdd) {
      if (this.aosToAdd.hasOwnProperty(group)) {
        this.clearAOGroup(this.aosToAdd[group]);
        for (var i = 0; i < this.aosToAdd[group].length; ++i) {
          if (!this.aosToAdd[group][i].dontAdd) {
            this.addAmbient(...this.aosToAdd[group][i].vals);
          }
        }
      }
    }
    this.aosToAdd = {};
  };

  // LIMIT AMB:
  this.limitAmb = function (l, data, d, v1, v2, obj1, obj2) {
    var v3 = [UTILS.cdv[v1]];
    var v4 = [UTILS.cdv[v2]];
    if (d == -Math.PI / 2 || d == Math.PI + Math.PI / 2) {
      l = Math.min(l, (data[v2] - Math.min(obj1[v2] - obj1[v4], obj2[v2] - obj2[v4])) / 2);
    } else {
      if (d == Math.PI / 2) {
        l = Math.min(l, (Math.max(obj1[v2] + obj1[v4], obj2[v2] + obj2[v4]) - data[v2]) / 2);
      } else {
        if (d == 0) {
          l = Math.min(l, (Math.max(obj1[v1] + obj1[v3], obj2[v1] + obj2[v3]) - data[v1]) / 2);
        } else {
          l = Math.min(l, (data[v1] - Math.min(obj1[v1] - obj1[v3], obj2[v1] - obj2[v3])) / 2);
        }
      }
    }
    return l;
  };

  // RESET ALL:
  this.resetAll = function () {
    this.aosToAdd = {};
    for (var i = 0; i < this.objects.length; ++i) {
      this.objects[i].active = true;
      if (this.objects[i].startHealth) {
        this.objects[i].health = this.objects[i].startHealth;
      }
      if (this.objects[i].meshRef) {
        this.objects[i].meshRef.visible = true;
      }
    }
    if (RENDER) {
      RENDER.updateShadowMap();
    }
  };

  // REMOVE ALL:
  this.removeAll = function () {
    this.objects.length = 0;
    this.objectives.length = 0;
    this.flags.length = 0;
    this.pickups.length = 0;
    this.teleporters.length = 0;
  };
};